/** Categorias padronizadas da base de conhecimento do agente IA. */
export const CONHECIMENTO_CATEGORIES = [
	{ value: "geral", label: "Geral" },
	{ value: "produtos", label: "Produtos / Serviços" },
	{ value: "precos", label: "Preços e valores" },
	{ value: "politicas", label: "Políticas e regras" },
	{ value: "procedimentos", label: "Procedimentos" },
	{ value: "faq", label: "FAQ / Dúvidas frequentes" },
	{ value: "horarios", label: "Horários e disponibilidade" },
	{ value: "atendimento", label: "Atendimento" },
	{ value: "transferencia", label: "Regras de transferência" },
	{ value: "outros", label: "Outros" },
];

const ALLOWED = new Set(CONHECIMENTO_CATEGORIES.map((c) => c.value));

export function normalizeConhecimentoCategory(raw) {
	const value = String(raw ?? "")
		.trim()
		.toLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "");
	if (ALLOWED.has(value)) return value;
	return "geral";
}

export function labelConhecimentoCategory(raw) {
	const value = normalizeConhecimentoCategory(raw);
	const found = CONHECIMENTO_CATEGORIES.find((c) => c.value === value);
	return found?.label ?? "Geral";
}
